import React from 'react';

/** On/off filter chip (e.g. "Posibles duplicados"). Pressed = brand tint; one click toggles it. */
export default function AuditFilterToggle({ active, onClick, icon, children }) {
    return (
        <button
            type="button"
            aria-pressed={!!active}
            onClick={onClick}
            className={`inline-flex h-9 items-center gap-1.5 rounded-lg border px-3 text-sm font-medium transition-colors ${
                active
                    ? 'border-primary-200 bg-primary-50 text-primary-700'
                    : 'border-surface-200 bg-white text-surface-700 hover:border-surface-300 hover:bg-surface-50'
            }`}>
            {icon && <span className="flex text-[15px]">{icon}</span>}
            {children}
        </button>
    );
}
